import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

const STORAGE_KEY = 'factory3d_editor_prefs'

interface EditorPrefs {
  showBadge: boolean
  preferPerformance: boolean
}

const DEFAULT_PREFS: EditorPrefs = {
  showBadge: true,
  preferPerformance: false,
}

function loadFromStorage(): EditorPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_PREFS }
    return { ...DEFAULT_PREFS, ...(JSON.parse(raw) as Partial<EditorPrefs>) }
  } catch (err) {
    console.debug('[editorPrefs] 偏好数据解析失败，已回退为默认', err)
    return { ...DEFAULT_PREFS }
  }
}

/**
 * 编辑器个人偏好：与工程/场景数据无关，不随 .f3p 保存或打开而变化。
 * 目前只有调试悬浮条展示（showBadge）和调试刷新节流（preferPerformance）。
 */
export const useEditorPrefsStore = defineStore('editorPrefs', () => {
  const loaded = loadFromStorage()
  const showBadge = ref(loaded.showBadge)
  const preferPerformance = ref(loaded.preferPerformance)

  watch([showBadge, preferPerformance], () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      showBadge: showBadge.value,
      preferPerformance: preferPerformance.value,
    }))
  })

  function setShowBadge(value: boolean) {
    showBadge.value = value
  }

  function setPreferPerformance(value: boolean) {
    preferPerformance.value = value
  }

  return { showBadge, preferPerformance, setShowBadge, setPreferPerformance }
})
